export const GET_ROOT_THEMES_REQUEST = 'THEMES.GET_ROOT_THEMES_REQUEST';
export const GET_ROOT_THEMES_SUCCESS = 'THEMES.GET_ROOT_THEMES_SUCCESS';
export const GET_ROOT_THEMES_ERROR = 'THEMES.GET_ROOT_THEMES_ERROR';

export const GET_THEMES_TREE_REQUEST = 'THEMES.GET_THEMES_TREE_REQUEST';
export const GET_THEMES_TREE_SUCCESS = 'THEMES.GET_THEMES_TREE_SUCCESS';
export const GET_THEMES_TREE_ERROR = 'THEMES.GET_THEMES_TREE_ERROR';
export const SET_THEMES_TREE_LOADING_STATUS = 'THEMES.SET_THEMES_TREE_LOADING_STATUS';

export const GET_ACTUAL_THEMES_REQUEST = 'THEMES.GET_ACTUAL_THEMES_REQUEST';
export const GET_ACTUAL_THEMES_SUCCESS = 'THEMES.GET_ACTUAL_THEMES_SUCCESS';
export const GET_ACTUAL_THEMES_ERROR = 'THEMES.GET_ACTUAL_THEMES_ERROR';
